import { defineComponent as _defineComponent } from 'vue'
import { createTextVNode as _createTextVNode, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createCommentVNode as _createCommentVNode, createBlock as _createBlock } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "table table-borderless table-sm table-responsive-sm"
}
const _hoisted_2 = { width: 200 }
const _hoisted_3 = {
  key: 2,
  class: "alert alert-info"
}

import { format_date } from '@/helpers/filters'
import * as moment from 'moment'
import { onBeforeMount, reactive, ref } from 'vue'
import { remindersApi } from '@/di/api'
import { Reminder } from "@/types/api";
import AppLoadingMessage from "@/components/app/AppLoadingMessage.vue";
import AppComponentHeader from "@/components/app/AppComponentHeader.vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'NearestReminders',
  setup(__props) {

const items = ref<Reminder[]>([])

const lock: { loading: boolean } = reactive({ loading: false })

onBeforeMount(() => load())

async function load (): Promise<void> {
  lock.loading = true

  try {
    items.value = (await remindersApi.getReminders({
      filter: {
        is_resolved: false,
        action_at: {
          from: moment().format('YYYY-MM-DD'),
          till: moment().add(1, 'M').format('YYYY-MM-DD')
        }
      },
      sort: {
        action_at: 'asc',
        created_at: 'asc'
      }
    })).items
  } finally {
    lock.loading = false
  }
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(AppComponentHeader, null, {
      default: _withCtx(() => [
        _createTextVNode("Your nearest reminders")
      ]),
      _: 1
    }),
    (items.value.length > 0)
      ? (_openBlock(), _createElementBlock("table", _hoisted_1, [
          _createElementVNode("tbody", null, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(items.value, (reminder) => {
              return (_openBlock(), _createElementBlock("tr", {
                key: reminder.id
              }, [
                _createElementVNode("td", _hoisted_2, _toDisplayString(_unref(format_date)(reminder.action_at, 'date_time')), 1),
                _createElementVNode("td", null, _toDisplayString(reminder.title), 1)
              ]))
            }), 128))
          ])
        ]))
      : (lock.loading)
        ? (_openBlock(), _createBlock(AppLoadingMessage, { key: 1 }, {
            default: _withCtx(() => [
              _createTextVNode("Loading nearest reminders")
            ]),
            _: 1
          }))
        : (_openBlock(), _createElementBlock("div", _hoisted_3, "No nearest unresolved reminders"))
  ]))
}
}

})